import React, {useEffect, useState} from 'react'
import Header from "../components/layout/Header"
import {useAppDispatch, useAppSelector} from "../hooks/redux"
import {IBreadCrumbs} from "../models"
import {useNavigate, useParams} from "react-router-dom"
import {getOrder} from "../store/actions/orderActions"
import leftFillNum from "../utils/leftFillNum"
import Loading from "../components/blocks/Loading/Loading"
import OrderDetail from "../components/blocks/OrderDetail/OrderDetail"
import classes from "../components/layout/Layout/Layout.module.scss"
import ModalSuccess from "../components/blocks/modals/ModalSuccess/ModalSuccess"
import ModalEditOrder from "../components/blocks/modals/ModalEditOrder"
import Button from "../components/generic/buttons/Button"

export default function OrderDetailPage() {

  const dispatch = useAppDispatch()
  const {order, isLoadingOrder, error} = useAppSelector(state => state.order)
  const [modalEditShown, modalEditToggle] = useState(false)
  const [modalAcceptShown, modalAcceptToggle] = useState(false)
  const [modalFinishShown, modalFinishToggle] = useState(false)
  const [modalCancelShown, modalCancelToggle] = useState(false)
  const [modalEditSuccessShown, modalEditSuccessToggle] = useState(false)
  const navigate = useNavigate()

  type params = {
    id: string
  }

  const {id} = useParams<params>()

  useEffect(() => {
    if (id) {
      dispatch(getOrder({id: Number(id)}))
    }
  }, [dispatch, id])

  const breadcrumbs: IBreadCrumbs = (order && order.id) ? {
    backUrl: "/order/",
    items: [
      "Заявки",
      `Заявка №${leftFillNum(order.id)}`
    ]
  } : {}

  const modalAccept = modalAcceptShown && <ModalSuccess
    close={() => modalAcceptToggle(false)}
    title={"Заявка принята!"}
  />

  const modalFinish = modalFinishShown && <ModalSuccess
    close={() => modalFinishToggle(false)}
    title={"Заявка завершена!"}
  />

  const modalEditSuccess = modalEditSuccessShown &&
    <ModalSuccess
      close={() => modalEditSuccessToggle(false)}
      title={"Заявка обновлена"}
    />

  const modalCancelSuccess = modalCancelShown &&
    <ModalSuccess
      close={() => modalCancelToggle(false)}
      title={"Заявка отменена"}
      headerIconColor={"red"}
    />

  const modalEdit = id && modalEditShown &&
    <ModalEditOrder
      editID={Number(id)}
      close={() => modalEditToggle(false)}
      editSuccess={modalEditSuccessToggle}
    />

  const renderError = error.length &&
    <div style={{textAlign: "center"}}>
      <p>Заявка {id && <span>№ {id}</span>} не найдена!</p>
      <Button onClick={() => navigate(`/order/`)}>Перейти к списку заявок</Button>
    </div>

  return (
    <>
      <div className={classes.header}>
        <Header breadcrumbs={breadcrumbs} showUser={true}/>
      </div>
      <div className={classes.content}>
        {isLoadingOrder && <Loading/>}
        {!isLoadingOrder && renderError}
        {!isLoadingOrder && !!order && !!order.id &&
          <OrderDetail
            modalEditToggle={modalEditToggle}
            modalAcceptToggle={modalAcceptToggle}
            modalFinishToggle={modalFinishToggle}
            modalCancelToggle={modalCancelToggle}
          />
        }
      </div>
      {modalAccept}
      {modalFinish}
      {modalEdit}
      {modalEditSuccess}
      {modalCancelSuccess}
    </>
  )
}